var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtualPcp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.78 129.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15798",
    d: "m37,86.73h30.94c1.79,0,3.24-1.45,3.24-3.24v-5.33c0-3.33,2.71-6.04,6.04-6.03.77,0,1.53.15,2.24.43l12.02,4.81c1.66.66,3.55-.14,4.21-1.81.15-.38.23-.79.23-1.21v-18.85c0-1.79-1.45-3.24-3.24-3.24-.41,0-.82.08-1.2.23l-12.02,4.81c-3.1,1.24-6.61-.27-7.85-3.37-.28-.71-.43-1.47-.43-2.23v-5.34c0-1.79-1.45-3.24-3.24-3.24h-30.94c-1.79,0-3.24,1.45-3.24,3.24v37.12c0,1.79,1.45,3.24,3.24,3.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15799",
    d: "m4.66,113.92c-1.77,4.72.62,9.99,5.34,11.76,1.91.72,3.99.77,5.94.17l12.19-3.81c2.31-.77,4.82-.61,7.01.45,9.16,4.78,19.35,7.28,29.68,7.27,4.59,0,9.17-.48,13.66-1.42,35.04-7.5,57.36-41.99,49.86-77.02C120.83,16.27,86.35-6.05,51.31,1.45,16.27,8.95-6.05,43.44,1.45,78.48c1.33,6.21,3.56,12.18,6.62,17.74,1.22,2.33,1.37,5.07.4,7.51l-3.82,10.19ZM27.87,46.37c0-5.04,4.09-9.13,9.13-9.13h30.94c5.04,0,9.13,4.09,9.13,9.13v5.33l12.23-4.67c4.68-1.87,10,.41,11.87,5.09.43,1.08.65,2.22.65,3.38v18.86c0,5.05-4.1,9.13-9.14,9.13-1.16,0-2.3-.22-3.38-.65l-12.02-4.81-.2,5.46c0,5.04-4.09,9.13-9.13,9.13h-30.94c-5.04,0-9.13-4.09-9.13-9.13v-37.12Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualPcp);
export default __webpack_public_path__ + "static/media/VirtualPCP.5ec08c8baf17ad58e225cdd0a5d8407e.svg";
export { ForwardRef as ReactComponent };